module.exports = require('./lib/credit-score');
